module.exports = __webpack_public_path__ + "img/tip_ks.66da918a.png";